var productModel = {
    columns : [
        {
            name : 'id',
            alias : 'id',
            type : 'string'
        },
        {
            name : 'img',
            alias : 'Preview',
            type : 'img'
        },
        {
            name : 'title',
            alias : 'Nome',
            type : 'string'
        },
        {
            name : 'status',
            alias : 'Stato',
            type : 'string'
        },
        {
            name : 'category',
            alias : 'Categoria',
            type : 'string'
        },
        {
            name : 'subCategory',
            alias : 'Sottocategoria',
            type : 'string',
        },
        {
            name : 'price',
            alias : 'Prezzo',
            type : 'string',
        },
        {
            name : 'timestamp',
            alias : 'Data',
            type : 'function',
            action : 'getDateFromTimestamp'
        },
        {
            name : 'actions',
            alias : 'Azioni',
            type : 'actionBlock',
            buttons : [
                {
                    name : 'edit product',
                    function : "editProduct",
                    agrument : 'item.id',
                    icon : 'fa-pencil',
                    color : 'black'
                },
                {
                    name : 'remove product',
                    function : 'removeProduct',
                    agrument : 'item.id',
                    icon : 'fa-trash',
                    color : 'red'
                }
            ]
        }
    ]
}

var orderModel = {
    hilighter : {
        active: true,
        basedOn: 'state',
        opt : {
            color : 'rgba(221, 155, 155, 0.28)',
            value : 'nuovo'
        }
    },
    columns : [
        {
            name : 'id',
            alias : 'Cod. Prodotto',
            type : 'string'
        },
        {
            name : 'userFullName',
            alias : 'Nome Utente',
            type : 'string'
        },
        {
            name : 'state',
            alias : 'Stato',
            type : 'string'
        },
        {
            name : 'tot',
            alias : 'Totale',
            type : 'string'
        },
        {
            name : 'timestamp',
            alias : 'Data e ora',
            type : 'function',
            action : 'getDateFromTimestamp'
        },
        {
            name : 'Actions',
            alias : 'Gestisci',
            type : 'actionBlock',
            buttons : [
                {
                    name : 'manage Order',
                    function : 'manageOrder',
                    agrument : 'item.sku',
                    icon : 'fa-cog',
                    color : 'black'
                }
            ]
        }
    ]
}

var shippingModel = {
    columns : [
        {
            name : 'country',
            alias : 'Destinazione',
            type : 'string'
        },
        {
            name : 'name',
            alias : 'Nome Servizio',
            type : 'string'
        },
        {
            name : 'price',
            alias : 'Prezzo',
            type : 'string'
        },
        {
            name : 'Actions',
            alias : 'edit',
            type : 'actionBlock',
            buttons : [
                {
                    name : 'edit shipping',
                    function : 'editShipping',
                    agrument : 'item.country',
                    icon : 'fa-pencil',
                    color : 'black'
                },
                {
                    name : 'remove shipping',
                    function : 'removeShipping',
                    agrument : 'item.country',
                    icon : 'fa-trash',
                    color : 'red'
                }
            ]
        }
    ]
}

var categoriesModel = {
    columns : [
        {
            name : 'name',
            alias : 'Nome',
            type : 'string',
        },
        {
            name : 'parent',
            alias : 'Categoria Padre',
            type : 'string'
        },
        {
            name : 'Actions',
            alias : 'actions',
            type : 'actionBlock',
            buttons : [
                {
                    name : 'edita categoria',
                    function : 'openCategoryForm',
                    agrument : 'item.name',
                    agrument2 : 'item.parent',
                    icon : 'fa-pencil',
                    color : 'black'
                },
                {
                    name : 'remove categories',
                    function : 'removeCategory',
                    agrument : 'item.name',
                    agrument2 : 'item.parent',
                    icon : 'fa-trash',
                    color : 'red'
                }
            ]
        }
    ]
}

var storeModel = {
    columns : [
        {
            name : 'id',
            alias : 'ID',
            type : 'string'
        },
        {
            name : 'img',
            alias : 'Preview',
            type : 'img'
        },
        {
            name : 'name',
            alias : 'Nome',
            type : 'string'
        },
        {
            name : 'category',
            alias : 'Categoria',
            type : 'string'
        },
        {
            name : 'subCategory',
            alias : 'Genere',
            type : 'string'
        },
        {
            name : 'available',
            alias : 'Disponibile',
            type : 'string'
        },
        {
            name : 'size',
            alias : 'Misura',
            type : 'string'
        },
        {
            name : 'qt',
            alias : 'Quantità',
            type : 'numberInput'
        }
    ]
}

var userModel = {
    columns : [
        {
            name : 'name',
            alias : 'Nome',
            type : 'string'
        },
        {
            name : 'surname',
            alias : 'Cognome',
            type : 'string'
        },
        {
            name : 'email',
            alias : 'Email',
            type : 'string'
        },
        {
            name : 'role',
            alias : 'Ruolo',
            type : 'string'
        },
        {
            name : 'Actions',
            alias : 'actions',
            type : 'actionBlock',
            buttons : [
                {
                    name : 'editTecnique',
                    function : 'editTecnique',
                    agrument : 'item.id',
                    icon : 'fa-pencil',
                    color : 'black'
                },
                {
                    name : 'remove tecnique',
                    function : 'removeTecnique',
                    agrument : 'item.id',
                    icon : 'fa-trash',
                    color : 'red'
                }
            ]
        }
    ]
}
